// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"472148b3","254":"16cf30ac","323":"7734cf94","343":"ddefa349","453":"195b869a","515":"cf510c2e","607":"02224da1","798":"6cb9cd6e"}[chunkId] + ".chunk.js";
};